import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  CurrencyComponent,
  ExternalLinkComponent,
  ImageThumbnailComponent,
  SlimButtonComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { PublicBoxDataSourceService } from '../../services/public-box-data-source.service';
import { Observable, switchMap } from 'rxjs';
import { PublicBoxDetails } from '../../models';
import { toObservable } from '@angular/core/rxjs-interop';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { PublicCartAddButtonComponent } from '@web/shared/module/shop';
import { BoxComponentGroupsPreviewComponent } from '@web/shared/module/shop';

@Component({
  selector: 'app-public-box-details',
  imports: [
    BoxComponentGroupsPreviewComponent,
    CommonModule,
    CurrencyComponent,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
    PublicCartAddButtonComponent,
    SlimButtonComponent,
    SpinnerFilledComponent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './public-box-details.component.html',
  styleUrl: './public-box-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxDetailsComponent {
  private readonly publicBoxDataSource = inject(PublicBoxDataSourceService);

  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly box$ = this.boxSource();
  protected readonly currentTabIndex = this.currentTabIndexSignal();

  public handleTabClick(index: number): void {
    this.currentTabIndex.set(index);
  }

  public isActiveTab(index: number): boolean {
    return this.currentTabIndex() === index;
  }

  protected isFirstTabActive(): boolean {
    return this.currentTabIndex() === 0;
  }

  private boxSource(): Observable<PublicBoxDetails> {
    return this.slug$.pipe(
      switchMap((slug) => this.publicBoxDataSource.fetchDetailsBySlug(slug)),
    );
  }

  private currentTabIndexSignal(): WritableSignal<number> {
    return signal<number>(0);
  }
}
